import { alpha, Box, Card, CardContent, CircularProgress, Divider, Grid, InputAdornment, Paper, Typography, useTheme } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import WSTextField, { CurrencyType, TextType } from "../../../Components/TextBox/WSTextBox";
import WSButton from "../../../Components/Button/WSButton";
import { callAPI, clearRequest, Method } from "../../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useNavigate, useParams } from "react-router-dom";
import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
import { Header } from "../../../Components/Header/Header";
import WSHiddenField from "../../../Components/HiddenField/WSHiddenField";
import WSSelectField from "../../../Components/Select/WSSelect";
import WSSCheckBoxField from "../../../Components/CheckBox/WSCheckBox";

export const Product: React.FC<any> = React.memo((props) => {

  const { control, register, handleSubmit, setValue, reset } = useForm();
  const { showMessage } = useSnackbar();
  const params = useParams();
  const navigate = useNavigate();
  const id = params?.id;
  const theme = useTheme();

  const [subitting, setSubmitting] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true)
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [defaultImg, setDefaultImg] = useState<string | null>(null);
  const hasLoadedRef = useRef(false);

  const source = {
    url: "brands/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: []
  };

  useEffect(() => {
    return () => {
      reset();
      hasLoadedRef.current = false;
    };
  }, []);

  useEffect(() => {
    /**
     * Edit Function
     * @param id
     *
     */
    async function getProductById(id: any) {
      try {
        setLoading(true)
        const response: any = await callAPI(`products/getBy`, Method.GET, {}, id);

        setValue("name", response.data.name);
        setValue("price", response.data.price?.toString() || "");
        setValue("discountPrice", response.data.discountPrice?.toString() || "");
        setValue("brand", response.data.brand?._id || "");
        if (response.data.description == 'undefined' || response.data.description == 'null') {
          setValue("description", "");
        } else {
          setValue("description", response.data.description || "");
        }
        setValue("isAvailable", response.data.isAvailable);


        const imageUrl = response.data.imageUrl?.toString() || null;

        setDefaultImg(imageUrl);

        // Mark as loaded
        hasLoadedRef.current = true;

      } catch (error) {
      } finally {
        setLoading(false)
      }
    }
    if (id && !hasLoadedRef.current) {
      getProductById(id);
    }
  }, [id, setValue]);

  /**
   * Method for Add/Update the data
   * @param data
   */


  const handleData = async (data: any) => {
    try {
      setSubmitting(true);
      const formData = new FormData()

      if (selectedFile) {
        formData.append("file", selectedFile!);
      }
      formData.append("name", data.name); // Add title
      formData.append("brand", data.brand);
      formData.append("description", data.description);
      formData.append("price", data.price);
      formData.append("discountPrice", data.discountPrice);
      // formData.append("stock", data.stock);
      formData.append("isAvailable", data.isAvailable);

      // const newRequest = clearRequest(request)
      if (id) {
        formData.append("id", id); // Add display
        const response: any = await callAPI(`products/update/${id}`, Method.PUTFORMDATA, null, null, formData);
        if (response) {
          showMessage(response?.message, response.success === true ? "success" : "error");
          if (response.success === true) {
            navigate('/product/list')
          }
        }

      } else {
        const response: any = await callAPI("products/create", Method.POSTFORMDATA, null, null, formData);
        if (response) {
          showMessage(response?.message, response.success === true ? "success" : "error");
          if (response.success === true) {
            navigate('/product/list')
          }
        }
      }
    } catch (e: any) {
      showMessage(e?.response?.data?.message || "something went wrong", 'error');
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancelClick = () => {
    navigate('/product/list')
  }
  const handleUploadFile = (file: any) => {
    setDefaultImg(null)
    if (file && file.length > 0) {
      setSelectedFile(file[0]);
    }
  }
  const handleRemove = (id: string) => {
    alert(id)
  }

  const transFormData = (data: any) => {
    let bannerList: Array<any> = [];
    data &&
      data?.map((item: any) => {
        bannerList.push({ label: `${item?.name}`, value: item._id });
      });
    return bannerList;
  };

  {
    loading && (
      <div style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255,255,255,0.7)',
        zIndex: 9999
      }}>
        <CircularProgress />
      </div>
    )
  }

  return (
    <>
      <Header
        type="simple"
        isDivider={true}
        title={`${id ? 'Edit' : 'Create'} Product`}
        url="/product/list"
        id={'productsListHeader'}
        isBackButton={true}
      />

      <form onSubmit={handleSubmit(handleData)}>
        <Card
          sx={{
            padding: 4,
            backgroundColor: "#fff",
            borderRadius: 3,
            marginTop: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
            border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
            background: 'linear-gradient(to bottom, #ffffff, #f8fbff)'
          }}
        >
          <CardContent>
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
              Product Information
            </Typography>

            <Grid container spacing={3}>

              {/* Product Name */}
              <Grid item xs={12} md={6}>
                <WSTextField
                  label={"Product Name"}
                  {...register("name")}
                  id="name"
                  name="name"
                  control={control}
                  rules={{ required: true }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: alpha(theme.palette.primary.light, 0.05),
                      '&:hover fieldset': {
                        borderColor: theme.palette.primary.main,
                      },
                    }
                  }}
                />
              </Grid>

              {/* Brand Select */}
              <Grid item xs={12} md={6}>
                <WSSelectField
                  label="Brand"
                  name="brand"
                  control={control}
                  rules={{ required: false }}
                  source={source}
                  transFormData={transFormData}
                  id="brand"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: alpha(theme.palette.primary.light, 0.05),
                      '&:hover fieldset': {
                        borderColor: theme.palette.primary.main,
                      },
                    }
                  }}
                />
              </Grid>

              {/* Price */}
              <Grid item xs={12} md={6}>
                <WSTextField
                  label={"Price"}
                  {...register("price")}
                  id="price"
                  name="price"
                  control={control}
                  type={TextType.Currency}
                  currency={CurrencyType.Rupee}
                  rules={{ required: true }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: alpha(theme.palette.primary.light, 0.05),
                    }
                  }}
                />
              </Grid>

              {/* Discount Price */}
              <Grid item xs={12} md={6}>
                <WSTextField
                  label={"Discount Price"}
                  {...register("discountPrice")}
                  id="discountPrice"
                  name="discountPrice"
                  control={control}
                  type={TextType.Currency}
                  currency={CurrencyType.Rupee}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: alpha(theme.palette.primary.light, 0.05),
                    }
                  }}
                />
              </Grid>

              {/* Stock */}
              {/* <Grid item xs={12} md={6}>
                <WSTextField
                  label={"Stock Quantity"}
                  {...register("stock")}
                  id="stock"
                  name="stock"
                  control={control}
                  type={TextType.Number}
                  rules={{ required: true, min: 0 }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: alpha(theme.palette.primary.light, 0.05),
                    }
                  }}
                />
              </Grid> */}

              {/* Description */}
              <Grid item xs={12} md={6}>
                <WSTextField
                  label={"Product Description"}
                  {...register("description")}
                  id="description"
                  name="description"
                  control={control}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: alpha(theme.palette.primary.light, 0.05),
                    }
                  }}
                />
              </Grid>

              {/* Availability */}
              <Grid item xs={12} md={6}>
                <WSSCheckBoxField
                  id="isAvailable"
                  label="Is Available?"
                  name="isAvailable"
                  rules={{ required: false }}
                  control={control}
                  defaultValue={true}
                />
              </Grid>

              {/* Image Upload */}
              <Grid item xs={12}>
                <Divider sx={{ my: 2 }} />
                <Typography
                  variant="h6"
                  sx={{
                    mb: 2,
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}
                >
                  Product Image
                </Typography>

                <Paper
                  variant="outlined"
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.primary.light, 0.03),
                    border: `1px dashed ${alpha(theme.palette.primary.main, 0.2)}`
                  }}
                >
                  <WSFileUpload
                    name="imageUrl"
                    label="Upload Product Image"
                    control={control}
                    rules={{ required: defaultImg ? false : true }}
                    acceptFileTypes=".jpg,.jpeg,.png"
                    maxFileSizeMB={2}
                    defaultValue={defaultImg}
                    id="imageUrl"
                    image={true}
                    onChange={handleUploadFile}
                    onRemove={handleRemove}
                    align="Start"
                    isToolTipImg={false}
                    multiple={false}
                  />
                </Paper>
                <Typography variant="caption" sx={{ color: 'text.secondary', mt: 1, display: 'block' }}>
                  Recommended: Square image, 500x500px, JPG or PNG format, Max 2MB
                </Typography>
              </Grid>

              {/* Hidden ID (if editing) */}
              <Grid item xs={12} sm={6} style={{ display: "none" }}>
                <WSHiddenField name="id" control={control} />
              </Grid>

              {/* Submit + Cancel Buttons */}
              <Grid
                item
                xs={12}
                sx={{
                  marginTop: "3rem",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                }}
              >
                <WSButton
                  id="submit"
                  label={"Save"}
                  type="submit"
                  size="small"
                  loading={subitting}
                />

                <WSButton
                  id="cancel"
                  label={"Cancel"}
                  type="button"
                  size="small"
                  className="ws-cancel"
                  loading={subitting}
                  onClick={handleCancelClick}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </form>
    </>
  );
});
